import { Grid, Text, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import TextInputWithTextDisplay from "../../LandingPage/FinanceCalculator/TextInputWithTextDisplay";
import { calcPayments } from "../../LandingPage/FinanceCalculator/calcPayments";

const MultiCalculatorPart = ({ form }) => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1200px)");
  const [months, setMonths] = useState([36, 48, 60, 72, 84]);
  const [downPayment, setDownPayment] = useState([1000, 2000, 3000]);
  const [apr, setApr] = useState([9, 12, 15, 18, 20]);
  const [selectedIndex, setSelectedIndex] = useState([0, 0]);
  // const [vehiclePrice, setVehiclePrice] = useState(0);
  // const vehiclePrice = form?.values?.vehicleRetailPrice ? parseInt(form?.values?.vehicleRetailPrice) : 0;
  const vehiclePrice = form?.values?.totalPrice ? parseFloat(form?.values?.totalPrice) : 0;
  const tradeIn = form?.values?.tradeIn ? parseFloat(form?.values?.tradeIn) : 0;
  const tradeInPayoff = form?.values?.tradeInPayoff ? parseFloat(form?.values?.tradeInPayoff) : 0;

  const frequency = useMemo(() => {
    switch (form?.values?.frequency) {
      case "Monthly":
        return 0;
      case "Semi-Monthly":
        return 1;
      case "Bi-Weekly":
        return 2;
      case "Weekly":
        return 3;
      default:
        return 0;
    }
  }, [form?.values?.frequency]);

  const termType = useMemo(() => {
    switch (form?.values?.frequency) {
      case "Monthly":
        return "months";
      case "Semi-Monthly":
        return "semi-mths";
      case "Bi-Weekly":
        return "bi-weeks";
      case "Weekly":
        return "weeks";
      default:
        return "months";
    }
  }, [form?.values?.frequency]);

  const [data, setData] = useState([
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const handleSubmit = useCallback(() => {
    const newData = [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ];

    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 5; j++) {
        const temp = calcPayments(vehiclePrice, tradeIn, tradeInPayoff, downPayment[i], months[j], 0, apr[j], true);
        newData[i][j] = temp.payments[frequency].payment;
      }
    }

    setData(newData);
  }, [months, downPayment, apr, vehiclePrice, tradeIn, frequency, tradeInPayoff]);

  useEffect(() => {
    handleSubmit();
  }, [handleSubmit]);

  useEffect(() => {
    const downPaymentIndex = selectedIndex[0] ? selectedIndex[0] : 0;
    const newDownPaymentArray = downPayment.map((item, index) => {
      if (index === downPaymentIndex) {
        return form.values.downPayment;
      } else {
        return item;
      }
    });
    setDownPayment(newDownPaymentArray);
  }, [form.values.downPayment]);

  useEffect(() => {
    const monthlyPayment = data[selectedIndex[0]][selectedIndex[1]];
    form.setFieldValue("monthlyPayment", monthlyPayment);
    form.setFieldValue("paymentPlan", data);
  }, [data]);

  useEffect(() => {
    form.setFieldValue("downPayments", downPayment);
  }, [downPayment]);

  useEffect(() => {
    form.setFieldValue("terms", months);
  }, [months]);

  useEffect(() => {
    form.setFieldValue("APRs", apr);
  }, [apr]);

  const handleCustomTextClick = (cashDownPaymentIndex, termIndex, APRIndex, monthlyPayment) => {
    form.setFieldValue("downPayment", downPayment[cashDownPaymentIndex]);
    form.setFieldValue("term", months[termIndex]);
    form.setFieldValue("APR", apr[APRIndex]);
    form.setFieldValue("monthlyPayment", monthlyPayment);
  };

  const handleChange = (getter, setter, index, value) => {
    setter(
      getter.map((item, i) => {
        if (i === index) {
          return value;
        } else {
          return item;
        }
      }),
    );
    if (setter === setMonths) {
      if (selectedIndex[1] === index) {
        form.setFieldValue("term", value);
      }
    } else if (setter === setDownPayment) {
      if (selectedIndex[0] === index) {
        form.setFieldValue("downPayment", value);
      }
    } else if (setter === setApr) {
      if (selectedIndex[1] === index) {
        form.setFieldValue("APR", value);
      }
    }
  };
  return (
    <Grid>
      <Grid.Col span={3}>
        <Text align="center" size={"sm"}>
          Cash Down
        </Text>
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={months[0]}
          type={termType}
          onChange={(e) => handleChange(months, setMonths, 0, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={months[1]}
          type={termType}
          onChange={(e) => handleChange(months, setMonths, 1, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={months[2]}
          type={termType}
          onChange={(e) => handleChange(months, setMonths, 2, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={downPayment[0]}
          type="currency"
          onChange={(e) => handleChange(downPayment, setDownPayment, 0, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[0][0]}
          onClick={() => handleCustomTextClick(0, 0, 0, data[0][0])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[0, 0]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[0][1]}
          onClick={() => handleCustomTextClick(0, 1, 1, data[0][1])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[0, 1]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[0][2]}
          onClick={() => handleCustomTextClick(0, 2, 2, data[0][2])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[0, 2]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={downPayment[1]}
          type="currency"
          onChange={(e) => handleChange(downPayment, setDownPayment, 1, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[1][0]}
          onClick={() => handleCustomTextClick(1, 0, 0, data[1][0])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[1, 0]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[1][1]}
          onClick={() => handleCustomTextClick(1, 1, 1, data[1][1])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[1, 1]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[1][2]}
          onClick={() => handleCustomTextClick(1, 2, 2, data[1][2])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[1, 2]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={downPayment[2]}
          type="currency"
          onChange={(e) => handleChange(downPayment, setDownPayment, 2, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[2][0]}
          onClick={() => handleCustomTextClick(2, 0, 0, data[2][0])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[2, 0]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[2][1]}
          onClick={() => handleCustomTextClick(2, 1, 1, data[2][1])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[2, 1]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <CustomText
          form={form}
          size={"sm"}
          value={data[2][2]}
          onClick={() => handleCustomTextClick(2, 2, 2, data[2][2])}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          index={[2, 2]}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <Text align="center" size={"sm"}>
          APR
        </Text>
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={apr[0]}
          type="percentage"
          onChange={(e) => handleChange(apr, setApr, 0, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={apr[1]}
          type="percentage"
          onChange={(e) => handleChange(apr, setApr, 1, e.target.value)}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <TextInputWithTextDisplay
          size="sm"
          value={apr[2]}
          type="percentage"
          onChange={(e) => handleChange(apr, setApr, 2, e.target.value)}
        />
      </Grid.Col>
    </Grid>
  );
};

const CustomText = ({ value, size, onClick, selectedIndex, setSelectedIndex, index, form }) => {
  return (
    <Text
      align="center"
      style={{
        backgroundColor: index[0] === selectedIndex[0] && index[1] === selectedIndex[1] ? "rgb(34, 139, 255,0.5)" : "rgba(0,0,0,0.1)",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={() => {
        setSelectedIndex(index);
        form.setFieldValue("selectedIndex", index);
        onClick();
      }}
      size={size ? size : "md"}
    >
      {parseFloat(value) < 0 || isNaN(parseFloat(value))
        ? "-"
        : parseFloat(value).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
    </Text>
  );
};

export default MultiCalculatorPart;
